export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13298.c84ff899.jpg";